"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.A18DateBoxComponent = void 0;
const core_1 = require("@angular/core");
const core_2 = require("@angular/material/core");
const date_box_helper_service_1 = require("@core/services/helpers/date-box-helper.service");
const language_service_1 = require("@core/services/language.service");
const language_settings_1 = require("@core/settings/language.settings");
const rxjs_1 = require("rxjs");
const i0 = __importStar(require("@angular/core"));
const i1 = __importStar(require("@core/services/language.service"));
const i2 = __importStar(require("@angular/material/core"));
const i3 = __importStar(require("@core/services/helpers/date-box-helper.service"));
const i4 = __importStar(require("@angular/material/datepicker"));
const i5 = __importStar(require("@angular/material/form-field"));
const i6 = __importStar(require("@angular/material/input"));
class A18DateBoxComponent {
    constructor(_languageService, _dateAdapter, _dateBoxHelperService) {
        this._languageService = _languageService;
        this._dateAdapter = _dateAdapter;
        this._dateBoxHelperService = _dateBoxHelperService;
        this.onChange = new core_1.EventEmitter();
        this.language = language_settings_1.SUPPORTED_LANGUAGES.en;
        this.datePickerSettings = {};
        this.language$ = new rxjs_1.Subscription();
    }
    ngOnInit() {
        // subscribe to object registered in related service
        this.language$ = this._languageService.language$.subscribe((language) => {
            this.language = language;
            this._dateAdapter.setLocale(this.language);
            console.log('Language changed to: ', this.language, language);
        });
    }
    ngOnDestroy() {
        this.language$.unsubscribe();
    }
}
exports.A18DateBoxComponent = A18DateBoxComponent;
A18DateBoxComponent.ɵfac = function A18DateBoxComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || A18DateBoxComponent)(i0.ɵɵdirectiveInject(i1.LanguageService), i0.ɵɵdirectiveInject(i2.DateAdapter), i0.ɵɵdirectiveInject(i3.DateBoxHelperService)); };
A18DateBoxComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: A18DateBoxComponent, selectors: [["a18-date-box"]], inputs: { dateBox: "dateBox", placeholder: "placeholder", required: "required", selectedDate: "selectedDate", dateFormat: "dateFormat", customClass: "customClass" }, outputs: { onChange: "onChange" }, decls: 9, vars: 3, consts: [["picker", ""], ["matInput", "", 3, "matDatepicker"], ["matIconSuffix", "", 3, "for"]], template: function A18DateBoxComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "mat-form-field")(1, "mat-label");
        i0.ɵɵtext(2);
        i0.ɵɵelementEnd();
        i0.ɵɵelement(3, "input", 1)(4, "mat-datepicker-toggle", 2)(5, "mat-datepicker", null, 0);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(7, "p");
        i0.ɵɵtext(8, "not implemented");
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        const picker_r1 = i0.ɵɵreference(6);
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate(ctx.placeholder);
        i0.ɵɵadvance();
        i0.ɵɵproperty("matDatepicker", picker_r1);
        i0.ɵɵadvance();
        i0.ɵɵproperty("for", picker_r1);
    } }, dependencies: [i4.MatDatepicker, i4.MatDatepickerInput, i4.MatDatepickerToggle, i5.MatFormField, i5.MatLabel, i5.MatSuffix, i6.MatInput], encapsulation: 2 });
